import React, { useState, useEffect } from "react";
import "./SelectInput.scss";
import InputLabel from "../InputLabel/InputLabel";
import { Addresses } from "utils/Addresses";

interface Props {
  lable: string;
  list: Array<any>;
  className: string;
  error: string | null;
  required: boolean;
  name: string;
  onChangeValue: (entry: string) => void;
  disabled?: boolean;
  defaultValue?: string;
  autoFocus?: boolean;
  hasEmptyOption?: boolean;
}

const DefaultSelectInput: React.FC<Props> = ({
  lable,
  list,
  className,
  error,
  required,
  name,
  onChangeValue,
  disabled,
  defaultValue,
  autoFocus = false,
  hasEmptyOption = false,
}) => {
  const [listData, setListData] = useState<Array<any>>([]);
  const [showList, setShowList] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");
  const [selectedItem, setSelectedItem] = useState<string>("");
  const [showInput, setShowInput] = useState<boolean>(false);

  let x = selectedItem;

  useEffect(() => {
    setListData(list);
    setInputValue("");
    setSelectedItem("");
    if (list.length > 0) {
      setShowInput(true);
      if (defaultValue !== undefined) {
        let title = list.find((item: any) => item.id == defaultValue);
        setInputValue(title.title);
        setSelectedItem(title.title);
      }
    }
  }, [list]);

  const handleSelect = (id: string, title: string) => {
    if (showList) {
      onChangeValue(id);
      setInputValue(title);
      setSelectedItem(title);
      x = title;
    }
  };

  const handelOnFocus = () => {
    setListData(list);
    setShowList(true);
  };

  const handelOnFocusOut = () => {
    setTimeout(() => {
      setShowList(false);
      setInputValue(x);
    }, 140);
  };

  const handelChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    setListData(list.filter((item) => item.title.toLowerCase().includes(e.target.value.toLowerCase())));
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {showInput ? (
        <>
          <InputLabel
            forId={name + "_select_input"}
            lable={lable}
            required={required}
          />
          <input
            disabled={disabled}
            id={name + "_select_input"}
            value={inputValue}
            className={className}
            onFocus={handelOnFocus}
            onChange={(e) => handelChangeInput(e)}
            onBlur={handelOnFocusOut}
            type="text"
            autoComplete="off"
            autoFocus={autoFocus}
          />
          <div
            style={{
              opacity: showList ? "1" : "0",
              zIndex: showList ? "10" : "0",
            }}
            className={"default-select-input-options-parent"}
          >
            {hasEmptyOption && listData.length > 0 ? (
              <p
              onClick={() => handleSelect('', '')}
                style={{
                  cursor: showList ? "pointer" : "default",
                }}
                key={-1}
              >
                Select
              </p>
            ) : (
              <></>
            )}
            {listData.map((item, key) => (
              <p
                onClick={() => handleSelect(item.id, item.title)}
                id={item.id}
                style={{
                  borderBottom: key == list.length - 1 ? "none" : "",
                  background:
                    item.title == selectedItem ? "rgb(243, 246, 253)" : "",
                  cursor: showList ? "pointer" : "default",
                }}
                key={key}
              >
                {item.title}
              </p>
            ))}
          </div>
          {error ? <span className="error-message">{error}</span> : null}
          <img
            style={{ transform: showList ? "rotate(-180deg)" : "rotate(0deg)" }}
            className="arrow-img"
            src={Addresses.icons.SELECT_INPUT_ARROW}
          />
        </>
      ) : (
        <div style={{ height: "59px" }}></div>
      )}
    </div>
  );
};
export default DefaultSelectInput;
